export const {
  VITE_API_BASE_PATH: API_BASE_PATH,
  VITE_API_PREFIX: API_PREFIX,
  VITE_SOCKET_PATH_NOTIFY: SOCKET_PATH_NOTIFY,
  VITE_SOCKET_NAMESPACE_NOTIFY: SOCKET_NAMESPACE_NOTIFY,
  VITE_SOCKET_PATH_RECORDS: SOCKET_PATH_RECORDS,
  VITE_SOCKET_NAMESPACE_RECORDS: SOCKET_NAMESPACE_RECORDS,
  // -------- Agregar aqui variables de entorno adicionales
  VITE_LICENSE_KEY_MUI: LICENSE_KEY_MUI,
} = import.meta.env;
